import {
  FETCH_PQT_ELEMENTS,
  FETCH_PQT_ELEMENTS_SUCCESS,
  FETCH_PQT_ELEMENTS_FAILURE,
  FETCH_PROJECT_PQT_REPORT,
  FETCH_PROJECT_PQT_REPORT_SUCCESS,
  FETCH_PROJECT_PQT_REPORT_FAILURE,
  UPDATE_PROJECT_PQT_REPORT,
  UPDATE_PROJECT_PQT_REPORT_SUCCESS,
  UPDATE_PROJECT_PQT_REPORT_FAILURE,
  CREATE_PROJECT_PQT_REPORT,
  CREATE_PROJECT_PQT_REPORT_SUCCESS,
  CREATE_PROJECT_PQT_REPORT_FAILURE,
  CREATE_PQT_ELEMENT,
  CREATE_PQT_ELEMENT_SUCCESS,
  CREATE_PQT_ELEMENT_FAILURE,
  FETCH_DSR_LOG_PQT,
  FETCH_DSR_LOG_PQT_SUCCESS,
  FETCH_DSR_LOG_PQT_FAILURE,
  UPDATE_DSR_LOG_PQT,
  UPDATE_DSR_LOG_PQT_SUCCESS,
  UPDATE_DSR_LOG_PQT_FAILURE,
} from './types';

export const fetchPqtElements = () => ({
  type: FETCH_PQT_ELEMENTS,
});

export const fetchPqtElementsSuccess = (payload) => ({
  type: FETCH_PQT_ELEMENTS_SUCCESS,
  ...payload,
});

export const fetchPqtElementsFailure = () => ({
  type: FETCH_PQT_ELEMENTS_FAILURE,
});

export const fetchProjectPqtReport = (projectId) => ({
  type: FETCH_PROJECT_PQT_REPORT,
  projectId,
});

export const fetchProjectPqtReportSuccess = (payload) => ({
  type: FETCH_PROJECT_PQT_REPORT_SUCCESS,
  ...payload,
});

export const fetchProjectPqtReportFailure = () => ({
  type: FETCH_PROJECT_PQT_REPORT_FAILURE,
});

export const updateProjectPqtReport = (payload) => ({
  type: UPDATE_PROJECT_PQT_REPORT,
  payload,
});

export const updateProjectPqtReportSuccess = (payload) => ({
  type: UPDATE_PROJECT_PQT_REPORT_SUCCESS,
  ...payload,
});

export const updateProjectPqtReportFailure = () => ({
  type: UPDATE_PROJECT_PQT_REPORT_FAILURE,
});

export const createProjectPqtReport = (payload) => ({
  type: CREATE_PROJECT_PQT_REPORT,
  payload,
});

export const createProjectPqtReportSuccess = (payload) => ({
  type: CREATE_PROJECT_PQT_REPORT_SUCCESS,
  ...payload,
});

export const createProjectPqtReportFailure = () => ({
  type: CREATE_PROJECT_PQT_REPORT_FAILURE,
});

export const createPqtElement = (payload) => ({
  type: CREATE_PQT_ELEMENT,
  payload,
});

export const createPqtElementSuccess = (payload) => ({
  type: CREATE_PQT_ELEMENT_SUCCESS,
  ...payload,
});

export const createPqtElementFailure = () => ({
  type: CREATE_PQT_ELEMENT_FAILURE,
});

export const fetchDsrLogPqt = (payload) => ({
  type: FETCH_DSR_LOG_PQT,
  payload,
});

export const fetchDsrLogPqtSuccess = (payload) => ({
  type: FETCH_DSR_LOG_PQT_SUCCESS,
  ...payload,
});

export const fetchDsrLogPqtFailure = () => ({
  type: FETCH_DSR_LOG_PQT_FAILURE,
});

export const updateDsrLogPqt = (payload) => ({
  type: UPDATE_DSR_LOG_PQT,
  payload,
});

export const updateDsrLogPqtSuccess = (payload) => ({
  type: UPDATE_DSR_LOG_PQT_SUCCESS,
  ...payload,
});

export const updateDsrLogPqtFailure = () => ({
  type: UPDATE_DSR_LOG_PQT_FAILURE,
});
